import { Button, Checkbox, Form, GetProp, InputNumber, Space, Upload, UploadFile, UploadProps } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";

import { useStore } from "../../config/store";
import { IClean } from "../../config/types";
import { API } from "../../api";
import { useState } from "react";
import { AxiosError } from "axios";

type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];
export const MetersBlock = () => {
  const { clean, cancelDrawer, reloadCleans, settings } = useStore();
  const { id } = clean as IClean;
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [fileUploading, setFileUploading] = useState(false);
  const [fileUploadError, setFileUploadError] = useState("");
  const [fields, setFields] = useState<any>({});
  const [uploadedFiles, setUploadedFiles] = useState<string[]>([])

  const meters = (settings?.meters_requested || ['cold_water', 'hot_water'])

  const onFinish = async (values: any) => {
    await API.meters.saveReadings({
      clean_id: id,
      ...values
    });

    await reloadCleans()
    cancelDrawer();
  };

  const handleFileUpload = async () => {
    if (fileList.length === 0) {
      return;
    }
    setFileUploading(true);
    const formData = new FormData();
    const fileToUpload = fileList.filter(file => !uploadedFiles.includes(file.uid))[0] as FileType;
    formData.append("file", fileToUpload);

    try {
      const response = await API.meters.uploadPhoto(formData);

      form.setFieldValue("photos", [...(fields.photos || []), response.url]);

      setUploadedFiles([...uploadedFiles, fileToUpload.uid]);
      setFileUploading(false);
      setFields(form.getFieldsValue());
    } catch (error) {
      if (error instanceof AxiosError) {
        setFileUploadError(error.response?.data);
      }

      setFileUploading(false);
    }
  };

  const fileProps: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
      setUploadedFiles(uploadedFiles.filter(f => f !== file.uid))
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
    },
    fileList: fileList,
    customRequest: handleFileUpload
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Form name="basic" form={form} onFinish={onFinish} autoComplete="off"
            layout="vertical">
        { meters.includes('cold_water') && <Form.Item label="Холодная вода" name="cold_water">
          <InputNumber />
        </Form.Item>}
        { meters.includes('hot_water') && <Form.Item label="Горячая вода" name="hot_water">
          <InputNumber />
        </Form.Item>}
        { meters.includes('electricity') && <Form.Item label="Электроэнергия" name="electricity">
          <InputNumber />
        </Form.Item>}
        { meters.includes('electricity_day') && <Form.Item label="Электроэнергия (день)" name="electricity_day">
          <InputNumber />
        </Form.Item>}
        { meters.includes('electricity_night') && <Form.Item label="Электроэнергия (ночь)" name="electricity_night">
          <InputNumber />
        </Form.Item>}
        { meters.includes('gas') && <Form.Item label="Газ" name="gas">
          <InputNumber />
        </Form.Item>}
        <Form.Item name="photos">
          <Space direction="vertical" style={{ width: "100%" }}>
            <Upload
              {...fileProps}
              listType="text"
            >
              <Button loading={fileUploading} icon={fileUploading ? <LoadingOutlined /> : <PlusOutlined />}>Загрузить фото</Button>
            </Upload>
            {fileUploadError && <div className="error">{fileUploadError}</div>}
          </Space>
        </Form.Item>

        <Space style={{ alignItems: "baseline" }}>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Сохранить показания
            </Button>
          </Form.Item>
          <Button onClick={() => cancelDrawer()}>Закрыть</Button>
        </Space>
      </Form>
    </Space>
  );
};
